import { SsoClientService } from '../services/SsoClientService';

export class SsoService {
  constructor(private ssoClientService: SsoClientService) {}

  public doLogout(): void {
    this.ssoClientService.doLogout();
  }

  public refreshPage(): void {
    window.location.reload();
  }
}
